var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotEqual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432 336C432 358.094 414.094 376 392 376H182.459L122.625 465.75C116.469 475 106.312 480 95.969 480C89.875 480 83.719 478.25 78.25 474.625C63.531 464.812 59.562 444.969 69.375 430.25L105.541 376H56C33.906 376 16 358.094 16 336S33.906 296 56 296H158.875L212.209 216H56C33.906 216 16 198.094 16 176S33.906 136 56 136H265.541L325.375 46.25C335.125 31.562 354.969 27.594 369.75 37.375C384.469 47.187 388.438 67.031 378.625 81.75L342.459 136H392C414.094 136 432 153.906 432 176S414.094 216 392 216H289.125L235.791 296H392C414.094 296 432 313.906 432 336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEqual);
export default __webpack_public_path__ + "static/media/not-equal.4bc2b3a63fe60c23bdb3c1a1f08130e1.svg";
export { ForwardRef as ReactComponent };